import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { SubscriptionExpiredComponent } from "../shared-module/components/subscription-expired/subscription-expired.component";
import { ModalController } from "@ionic/angular";
import { MatDialog } from "@angular/material/dialog";
import { DeleteConfirmDialogComponent } from "../shared-module/components/delete-confirm-dialog/delete-confirm-dialog.component";
import { DialogEditTeamComponent } from "../shared-module/components/dialog-edit-team/dialog-edit-team.component";
import { EncryptionService } from "../services/encryption.service";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  modalController: any;
  readonly dialog = inject(MatDialog);
  constructor(private http: HttpClient, private modal: ModalController, private encryptionService: EncryptionService) {}

  private isDeleteShortList = new Subject<any>();
  private isInvitaionRespo = new Subject<any>();
  private isPropertyActivity = new Subject<any>();
  private isCallingResponseSave = new Subject<any>();
  private isCallingContactAssign = new Subject<any>();
  private isCallingContactLead = new Subject<any>();
  private isSaveProjectProperty = new Subject<any>();
  private isImageUploaded = new Subject<any>();
  private isFloorPlanUploaded = new Subject<any>();
  private isBrowserBackButton = new Subject<any>();
  private isUserLoggedIn = new Subject<any>();
  private isPropertyImageDeleted = new Subject<any>();
  private isProjectImageDeleted = new Subject<any>();
  private isProjectSeeAll = new Subject<any>();
  private isAgentConnection = new Subject<any>();
  private isPropertyActiveDeactive = new Subject<any>();


  deleteData(type, Id, header, message) {
    this.dialog.open(DeleteConfirmDialogComponent, {
      data: { type: type, message: message, header: header, Id: Id },
      enterAnimationDuration: 500,
      exitAnimationDuration: 300,
      panelClass: "delete-custom-dialog",
      hasBackdrop: true,
      disableClose: true,
    });
  }
  editTeam(type, empList,data) {
    empList.forEach(element => {
      element.isSelected = false;
    });
    this.dialog.open(DialogEditTeamComponent, {
      data: { type: type, empList: empList ,data: data },
      enterAnimationDuration: 500,
      exitAnimationDuration: 300,
      hasBackdrop: true,
      disableClose: true,
    });
  }

  public get getShortListDelete() {
    return this.isDeleteShortList.asObservable();
  }
  public get getnvitaionRespo() {
    return this.isInvitaionRespo.asObservable();
  }

  setProjectSeeAll(value) {
    this.isProjectSeeAll.next(value);
  }
  public get getProjectSeeAll() {
    return this.isProjectSeeAll.asObservable();
  }
  setIsShortlistDelete(value) {
    this.isDeleteShortList.next(value);
  }
  public get getPropertyActivity() {
    return this.isPropertyActivity.asObservable();
  }

  setPropertyActivity(value) {
    this.isPropertyActivity.next(value);
  }
  setInvitaionRespo(value) {
    this.isInvitaionRespo.next(value);
  }
  setCallingResponseSave(value) {
    this.isCallingResponseSave.next(value);
  }
  public get getCallingResponseSave() {
   return this.isCallingResponseSave.asObservable();  
  }
  setCallingContactAssign(value) {
    this.isCallingContactAssign.next(value);
  }
  public get getCallingContactAssign() {
   return this.isCallingContactAssign.asObservable();  
  }
  setCallingLead(value) {
    this.isCallingContactLead.next(value);
  }
  public get getCallingContactLead() {
   return this.isCallingContactLead.asObservable();  
  }
  setSaveProjectProperty(value) {
    this.isSaveProjectProperty.next(value);
  }
  public get getSaveProjectProperty() {
   return this.isSaveProjectProperty.asObservable();  
  }
  setImageUploaded(value) {
    this.isImageUploaded.next(value);
  }
  public get getImageUploaded() {
   return this.isImageUploaded.asObservable();  
  }
  setFloorPlanUploaded(value) {
    this.isFloorPlanUploaded.next(value);
  }
  public get getFloorPlanUploaded() {
   return this.isFloorPlanUploaded.asObservable();  
  }
  setBrowserBackButton(value) {
    this.isBrowserBackButton.next(value);
  }
  public get getBrowserBackButton() {
   return this.isBrowserBackButton.asObservable();  
  }
  setUserLoggedIn(value) {
    this.isUserLoggedIn.next(value);
  }
  public get getUserLoggedIn() {
   return this.isUserLoggedIn.asObservable();  
  }
  setProjectImageDeleted(value) {
    this.isProjectImageDeleted.next(value);
  }
  public get getProjectImageDeleted() {
   return this.isProjectImageDeleted.asObservable();  
  }
  setPropertyImageDeleted(value) {
    this.isPropertyImageDeleted.next(value);
  }
  public get getPropertyImageDeleted() {
   return this.isPropertyImageDeleted.asObservable();  
  }
  setAgentConnection(value) {
    this.isAgentConnection.next(value);
  }
  public get getAgentConnection() {
   return this.isAgentConnection.asObservable();  
  }
  setPropertyActiveDeactive(value) {
    this.isPropertyActiveDeactive.next(value);
  }
  public get getPropertyActiveDeactive() {
   return this.isPropertyActiveDeactive.asObservable();  
  }

  isAccountExpired() {
    if (this.encryptionService.decryptUsingAES256(JSON.parse(localStorage.getItem("isExpired")))) {
      return true;
    } else {
      return false;
    }
  }
  async modalOpen() {
    this.modalController = await this.modal.create({
      component: SubscriptionExpiredComponent,
      cssClass: "expired-dialog-css",
    });
    this.modalController.present();
  }
  dsmissModal() {
    this.modalController.dismiss();
  }
}
